// Arabic dictionary — statically imported since Arabic is Calofay's default
// language. Keeping it in a dedicated module lets us tree-shake the English
// dictionary onto its own lazy chunk (see ./en-dict.js + i18n.jsx).
const AR = {
  // ── Common ────────────────────────────────────────────────────────────
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "common.delete": "حذف",
  "common.edit": "تعديل",
  "common.back": "رجوع",
  "common.confirm": "تأكيد",
  "common.loading": "جاري التحميل...",
  "common.saving": "جاري الحفظ...",
  "common.copy": "نسخ",
  "common.copied": "تم النسخ",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.close": "إغلاق",

  // ── Bottom Nav ────────────────────────────────────────────────────────
  "nav.home": "الرئيسية",
  "nav.progress": "تقدمي",
  "nav.recipes": "الوصفات",
  "nav.workouts": "التمارين",
  "nav.coach": "الشات",
  "nav.settings": "الإعدادات",

  // ── Settings page ─────────────────────────────────────────────────────
  "settings.title": "الإعدادات",
  "settings.theme_light": "الوضع الفاتح",
  "settings.theme_dark": "الوضع الداكن",
  "settings.theme_hint": "اضغط للتبديل",
  "settings.section_nutrition": "التغذية والأهداف",
  "settings.goals_row": "تحديث الأهداف والتغذية",
  "settings.mode_current": "الوضع الحالي:",
  "settings.mode_auto": "تلقائي",
  "settings.mode_manual": "يدوي",
  "settings.include_exercise_title": "إضافة سعرات التمارين إلى اليوم",
  "settings.include_exercise_desc": "عند التفعيل: تُضاف السعرات المحروقة إلى هدفك اليومي.",
  "settings.include_exercise_note": "التبديل يؤثر فقط على التمارين المستقبلية.",
  "settings.support_title": "تواصل مع خدمة العملاء وأخصائية التغذية",
  "settings.support_desc": "عندك سؤال أو تحتاج إلى مساعدة؟ تواصل معنا وحنساعدك توصل لهدفك.",
  "settings.share_title": "أصحابك يستاهلون يعرفونه",
  "settings.share_desc": "تعرف أحد ناوي يهتم بصحته؟ شاركه التطبيق وخلّه يبدأ معك.",
  "settings.share_text": "جرب كالوفاي معي! تطبيق ذكي لتتبع سعراتك وأكلك بالعربي 🚀",
  "settings.logout": "تسجيل الخروج",
  "settings.logout_confirm_title": "تأكيد تسجيل الخروج",
  "settings.logout_confirm_body": "راح تحتاج تسجّل دخول مرة ثانية بإيميلك وكلمة السر عشان ترجع لبياناتك.",
  "settings.logout_confirm_yes": "نعم، سجّل خروج",

  // ── Profile page ──────────────────────────────────────────────────────
  "profile.title": "ملفي الشخصي",
  "profile.member_id": "رقم العضوية",
  "profile.member_id_hint": "شارك هذا الرقم مع مدربك ليتمكّن من تمييز حسابك بسهولة.",
  "profile.email": "البريد الإلكتروني",
  "profile.signup_date": "تاريخ التسجيل",
  "profile.section_account": "حسابي",
  "profile.change_password": "تغيير كلمة المرور",
  "profile.language": "اللغة",
  "profile.help_support": "المساعدة والدعم",
  "profile.section_legal": "الشروط والسياسات",
  "profile.terms": "الشروط والأحكام",
  "profile.privacy": "سياسة الخصوصية",
  "profile.section_danger": "منطقة الخطر",
  "profile.reset_onboarding": "إعادة ضبط الأسئلة الترحيبية",
  "profile.delete_account": "حذف الحساب وإلغاء الاشتراك",

  // Editable name modal
  "profile.name_edit": "تعديل الاسم",
  "profile.name_placeholder": "اكتب اسمك",
  "profile.name_saved": "تم حفظ الاسم",
  "profile.name_save_fail": "تعذّر الحفظ",

  // Avatar
  "profile.change_photo": "تغيير الصورة",
  "profile.remove_photo": "إزالة الصورة",
  "profile.remove_photo_confirm_title": "إزالة الصورة الشخصية؟",
  "profile.remove_photo_confirm_body": "راح ترجع الصورة إلى شكل الأحرف الأولى من اسمك.",
  "profile.photo_removed": "تم إزالة الصورة",
  "profile.photo_upload_fail": "تعذّر رفع الصورة",

  // Reset onboarding modal
  "profile.reset_title": "إعادة ضبط الأسئلة الترحيبية؟",
  "profile.reset_body": "راح تعيد الإجابة على أسئلة كالوفاي الترحيبية وتحديد أهدافك من جديد. بياناتك ووجباتك السابقة ما راح تنمسح.",
  "profile.reset_confirm": "نعم، إعادة الأسئلة",
  "profile.reset_done": "تم إعادة الضبط",

  // Delete account survey
  "profile.delete_title": "حذف الحساب؟",
  "profile.delete_warn": "هذي الخطوة نهائية — ما نقدر نرجّع البيانات بعد الحذف. راح يتم إلغاء اشتراكك عبر واتساب.",
  "profile.delete_why": "ليش تبغى تحذف؟",
  "profile.delete_reason_price": "السعر عالي",
  "profile.delete_reason_features": "المزايا ما كافية",
  "profile.delete_reason_bugs": "التطبيق فيه مشاكل",
  "profile.delete_reason_stopped": "وقفت أهتم بصحتي",
  "profile.delete_reason_other": "سبب ثاني",
  "profile.delete_note_placeholder": "شاركنا رأيك (اختياري) — يساعدنا نتحسن",
  "profile.delete_send_wa": "تواصل عبر واتساب لإكمال الحذف",

  // ── Language Picker ───────────────────────────────────────────────────
  "settings.language": "اللغة",
  "lang.arabic": "العربية",
  "lang.english": "English",
  "lang.beta_ar": "التطبيق تم تصميمه للغة العربية أولاً. الترجمة الإنجليزية قيد التطوير — بعض الشاشات لا تزال بالعربية.",

  // ── Screens still in Arabic-only (shown as a subtle banner when EN) ──
  "banner.translation_in_progress": "هذي الشاشة قيد الترجمة إلى الإنجليزية.",

  // ── Dashboard ─────────────────────────────────────────────────────────
  "dash.loading": "جاري التحميل...",
  "dash.viewing_past_day": "أنت تشاهد يوماً سابقاً — يمكنك تسجيل بيانات كنت نسيتها.",
  "dash.back_to_today": "العودة لليوم",
  "dash.future_no_log": "لا يمكن التسجيل ليوم مستقبلي",
  "dash.streak_aria": "عرض السلسلة",
  "meal.breakfast": "الإفطار",
  "meal.lunch": "الغداء",
  "meal.dinner": "العشاء",
  "meal.snack": "سناك",
  "dash.calories_remaining": "السعرات الحرارية المتبقية",
  "dash.calories_over": "زائد عن الهدف",
  "dash.consumed": "المستهلكة",
  "dash.burned": "المحروقة",
  "macro.protein": "البروتين",
  "macro.fat": "الدهون",
  "macro.carbs": "الكربوهيدرات",
  "macro.remaining": "المتبقي",
  "macro.over": "زائد",
  "dash.meals_title": "تناول الطعام",
  "dash.calories_unit": "السعرات الحرارية",
  "dash.no_meals_yet": "لا توجد عناصر مسجلة بعد",
  "dash.delete_meal_title": "حذف الوجبة؟",
  "dash.deleted": "تم الحذف",
  "dash.calories_short": "سعرة",
  "dash.water_title": "متعقب الماء",
  "dash.water_liter": "لتر",
  "dash.water_add": "إضافة",
  "dash.water_edit_goal_aria": "تعديل هدف الماء",
  "dash.water_added": "أضيف",
  "dash.water_goal_updated": "تم تحديث هدف الماء",
  "dash.steps_title": "خطوات",
  "dash.steps_remaining": "متبقّي",
  "dash.steps_unit": "خطوة",
  "dash.steps_target_beat": "🎉 تجاوزت الهدف!",
  "dash.steps_log_btn": "سجّل خطواتك",
  "dash.steps_goal_btn": "الهدف",
  "dash.steps_log_title": "سجّل خطوات اليوم",
  "dash.steps_goal_title": "هدف الخطوات اليومي",
  "dash.steps_delete_title": "حذف الخطوات؟",
  "dash.steps_delete_body": "سيتم مسح تسجيل الخطوات لهذا اليوم.",
  "dash.steps_logged": "تم تسجيل الخطوات",
  "dash.steps_goal_updated": "تم تحديث هدف الخطوات",
  "dash.activity_title": "أنشطة",
  "dash.activity_log_btn": "سجل النشاط",
  "dash.activity_none": "لم يُسجَّل أي نشاط بعد",
  "dash.activity_minute": "دقيقة",
  "dash.activity_kcal_unit": "سعرة",
  "dash.activity_counted": "يُحسب",
  "dash.activity_recorded_only": "سجلّي",
  "dash.activity_counted_tt": "هذا التمرين مُضَاف لهدف اليوم",
  "dash.activity_not_counted_tt": "هذا التمرين لم يُضَف للهدف اليومي (كانت الخاصية مُطفأة وقت التسجيل)",
  "dash.activity_delete_aria": "حذف النشاط",
  "dash.addmeal.camera": "تصوير الوجبة (AI)",
  "dash.addmeal.camera_desc": "التقط صورة ودع الذكاء الاصطناعي يحللها.",
  "dash.addmeal.describe": "اشرح الوجبة (AI)",
  "dash.addmeal.describe_desc": "اكتب ما أكلته بلغتك الخاصة.",
  "dash.addmeal.barcode": "مسح باركود المنتج",
  "dash.addmeal.barcode_desc": "امسح باركود العلبة واحصل على المعلومات فوراً.",
  "dash.addmeal.label": "تصوير ملصق التغذية",
  "dash.addmeal.label_desc": "التقط صورة للملصق — الذكاء الاصطناعي يقرأ لك الماكرو.",
  "dash.addmeal.manual": "إدخال يدوي",
  "dash.addmeal.manual_desc": "أضف المكونات والسعرات يدوياً.",
  "dash.addmeal.recipes": "وصفاتي المحفوظة",
  "dash.addmeal.recipes_desc": "أضف وجبة من الوصفات اللي حفظتها",

  // ── Progress page ─────────────────────────────────────────────────────
  "prog.title": "تقدمي",
  "prog.tab_week": "أسبوع",
  "prog.tab_month": "شهر",
  "prog.tab_year": "سنة",
  "prog.weight": "الوزن",
  "prog.weight_current": "الوزن الحالي",
  "prog.weight_change": "التغير",
  "prog.weight_target": "الهدف",
  "prog.weight_log": "سجّل وزنك",
  "prog.weight_no_data": "لم يُسجَّل أي وزن بعد",
  "prog.calories": "السعرات",
  "prog.steps": "الخطوات",
  "prog.water": "الماء",
  "prog.exercise": "التمارين",
  "prog.avg": "متوسط",
  "prog.total": "الإجمالي",
  "prog.days_logged": "أيام مُسجّلة",
  "prog.photos": "صور التقدم",
  "prog.no_photos": "لا توجد صور بعد",
  "prog.add_photo": "أضف صورة",

  // ── Change Password ───────────────────────────────────────────────────
  "pwd.title": "تغيير كلمة المرور",
  "pwd.hint": "سنطلب كلمة المرور الحالية للتأكد من هويتك — كلمة المرور الجديدة 6 أحرف على الأقل.",
  "pwd.current": "كلمة المرور الحالية",
  "pwd.new": "كلمة المرور الجديدة",
  "pwd.confirm": "تأكيد كلمة المرور الجديدة",
  "pwd.submit": "تغيير كلمة المرور",
  "pwd.mismatch": "كلمتا المرور غير متطابقتين",
  "pwd.too_short": "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
  "pwd.updated": "تم تحديث كلمة المرور بنجاح",
  "pwd.wrong_current": "كلمة المرور الحالية غير صحيحة",

  // ── AI Coach ──────────────────────────────────────────────────────────
  "coach.title": "الشات",
  "coach.subtitle": "متصل الآن",
  "coach.placeholder": "اسألني أي شيء عن التغذية أو تقدمك...",
  "coach.send": "إرسال",
  "coach.empty_hi": "أهلاً {name}! أنا مدربك الذكي 👋",
  "coach.empty_desc": "أقدر أساعدك في تحليل تقدمك، خطة أكلك، اقتراح وجبات، وأي سؤال يخص رحلتك الصحية.",
  "coach.suggest_calories": "كم سعرة باقيلي اليوم؟",
  "coach.suggest_meal": "اقترح لي وجبة صحية",
  "coach.suggest_progress": "كيف تقدّمي هذا الأسبوع؟",
  "coach.thinking": "المدرب يفكّر...",
  "coach.error": "تعذّر الرد الآن — حاول مرة ثانية",
  "coach.clear_chat": "مسح المحادثة",

  // ── Update Goals ──────────────────────────────────────────────────────
  "goals.title": "تحديث الأهداف والتغذية",
  "goals.mode_auto": "تعديل تلقائي",
  "goals.mode_manual": "تعديل يدوي",
  "goals.section_basic": "معلومات أساسية",
  "goals.gender": "الجنس",
  "goals.male": "ذكر",
  "goals.female": "أنثى",
  "goals.age": "العمر",
  "goals.height": "الطول",
  "goals.height_cm": "سم",
  "goals.height_ft": "قدم",
  "goals.weight": "الوزن الحالي",
  "goals.weight_kg": "كجم",
  "goals.weight_lb": "رطل",
  "goals.target_weight": "الوزن المرغوب",
  "goals.activity_title": "مستوى النشاط (خارج التمارين)",
  "goals.activity_sedentary": "غير نشط جداً",
  "goals.activity_sedentary_desc": "معظم اليوم جالس (وظيفة مكتبية · أقل من 5,000 خطوة/يوم)",
  "goals.activity_light": "نشط قليلاً",
  "goals.activity_light_desc": "بعض المشي أو الوقوف خلال اليوم (5,000-7,500 خطوة/يوم)",
  "goals.activity_moderate": "نشط بشكل معتدل",
  "goals.activity_moderate_desc": "على قدميك معظم اليوم (7,500-10,000 خطوة/يوم)",
  "goals.activity_high": "نشط جداً",
  "goals.activity_high_desc": "عمل بدني أو الكثير من المشي (أكثر من 10,000 خطوة/يوم)",
  "goals.goal": "هدفك",
  "goals.goal_lose": "إنقاص الوزن",
  "goals.goal_maintain": "الحفاظ على الوزن",
  "goals.goal_gain": "زيادة الوزن",
  "goals.pace": "معدل التغيّر",
  "goals.pace_slow": "بطيء",
  "goals.pace_moderate": "معتدل",
  "goals.pace_fast": "سريع",
  "goals.save": "حفظ الأهداف",
  "goals.saved": "تم تحديث أهدافك",
  "goals.save_fail": "تعذّر الحفظ — حاول مرة ثانية",
  "goals.manual_calories": "السعرات اليومية",
  "goals.manual_protein": "البروتين (غ)",
  "goals.manual_carbs": "الكربوهيدرات (غ)",
  "goals.manual_fat": "الدهون (غ)",
  "goals.manual_water": "الماء (لتر)",
  "goals.manual_steps": "الخطوات اليومية",

  // ── Add Meal ──────────────────────────────────────────────────────────
  "addmeal.title": "إضافة وجبة",
  "addmeal.name": "اسم الوجبة",
  "addmeal.ingredients": "المكونات",
  "addmeal.add_ingredient": "إضافة مكوّن",
  "addmeal.ingredient_name": "اسم المكوّن",
  "addmeal.amount": "الكمية",
  "addmeal.unit_g": "غ",
  "addmeal.unit_ml": "مل",
  "addmeal.calories": "سعرات (kcal)",
  "addmeal.protein": "بروتين (غ)",
  "addmeal.carbs": "كارب (غ)",
  "addmeal.fat": "دهون (غ)",
  "addmeal.notes": "ملاحظات الوجبة",
  "addmeal.notes_placeholder": "أضف ملاحظة عن الوجبة (اختياري)",
  "addmeal.total": "إجمالي الوجبة",
  "addmeal.submit": "أدخل الوجبة",
  "addmeal.submit_and_save": "أدخل الوجبة واحفظ في مفضلاتي",
  "addmeal.saved": "تم إضافة الوجبة",

  // ── Recipes ───────────────────────────────────────────────────────────
  "recipes.title": "الوصفات الصحية",
  "recipes.tab_platform": "وصفات المنصة",
  "recipes.tab_saved": "وصفاتي المحفوظة",
  "recipes.tab_imported": "وصفاتي المستوردة",
  "recipes.tab_shopping": "قائمة التسوق",
  "recipes.search_placeholder": "ابحث عن وصفة...",
  "recipes.empty_platform": "لا توجد وصفات متاحة حالياً",
  "recipes.empty_saved": "ما عندك أي وصفات محفوظة بعد",
  "recipes.empty_imported": "استورد وصفتك الأولى من TikTok أو Instagram أو YouTube",
  "recipes.import_url": "استيراد وصفة من رابط",
  "recipes.import_placeholder": "الصق رابط TikTok أو Instagram أو YouTube",
  "recipes.import_btn": "استيراد",
  "recipes.importing": "جاري الاستيراد...",
  "recipes.import_done": "تم استيراد الوصفة",
  "recipes.import_fail": "تعذّر استيراد الوصفة",
  "recipes.load_more": "عرض المزيد",
};

export default AR;
